import React from "react";
import ComicBase from "../../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="La Viuda De Mi Vecina Capítulo 25– Rose Blue 3D"
      portada="https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-01.webp"
  paginas={[
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-01.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-02.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-03.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-04.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-05.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-06.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-07.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-08.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-09.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-10.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-11.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-12.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-13.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-14.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-15.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-16.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-17.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-18.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-19.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-20.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-21.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-22.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-23.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-24.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-25.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-26.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-27.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-28.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-29.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-30.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-31.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-32.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-33.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-34.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-35.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-36.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-37.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-38.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-39.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-40.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-41.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-42.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-43.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-44.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-45.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-46.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-47.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-48.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-49.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-50.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-51.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-52.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-53.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-54.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-55.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-56.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-57.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-58.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-59.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-60.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-61.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-62.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-63.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-64.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-65.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-66.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-67.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-68.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-69.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-70.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-71.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-72.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-73.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-74.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-75.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-76.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-77.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-78.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-79.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-80.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-81.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-82.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-83.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-84.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-85.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-86.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-87.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-88.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-89.webp",
  "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-90.webp"
]}
      sugeridos={[]}


      info={{
           grupo: "RoseBlue3D",
    tipo: "Comic 3D",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["3D", "Black Widow", "Corrupción", "Creampie", "Gafas", "Garganta Profunda", "Lencería", "Marvel", "MILF", "Parodia", "Pechos Grandes", "RoseBlue3D", "Seducida"],
    artistas: "Rose Blue 3D",
      }}
    />
  );
}

export const infoManga = {
  titulo: "La Viuda De Mi Vecina Capítulo 25– Rose Blue 3D",
  portada: "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-01.webp",
  reverso: "https://reycomiximg.com/wp-content/uploads/2025/03/My-Neighbors-Widow-25-RoseBlue3D-XXX-53.webp",
   fecha:"2026-05-17",


  info: {
       grupo: "RoseBlue3D",
    tipo: "Comic 3D",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["3D", "Black Widow", "Corrupción", "Creampie", "Gafas", "Garganta Profunda", "Lencería", "Marvel", "MILF", "Parodia", "Pechos Grandes", "RoseBlue3D", "Seducida"],
    artistas: "Rose Blue 3D",
  },
};
